import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SimulatorPage} from './simulator-page/simulator.page';

const routes: Routes = [
    {
        path: '', redirectTo: 'tdm', pathMatch: 'full'
    },
    {
        path: 'tdm',
        component: SimulatorPage,
        data: {type: 'tdm'}
    },
    {
        path: 'edm',
        component: SimulatorPage,
        data: {type: 'edm'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class SimulatorRoutingModule {
}
